var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNoImage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 51.08 44.123",
    "aria-labelledby": "noImageIcon noImageDesc"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.564 3.575V34.98l7.579-6.5a2.238 2.238 0 013.253 0l5.336 5.336 12.314-12.3a2.238 2.238 0 013.253 0l12.217 11.142V3.575zM48.59 37.94a2.232 2.232 0 01-.462-.322L33.667 24.241l-12.3 13.377a2.244 2.244 0 01-3.253 0l-5.346-6.409-8.266 9.34H48.59zM4.638 44.123A4.655 4.655 0 010 39.475V4.649A4.655 4.655 0 014.638 0h41.8a4.655 4.655 0 014.642 4.649v34.826a4.655 4.655 0 01-4.638 4.649z"
  })));
}

export default SvgNoImage;